export const LOGIN = '/login';
export const FORGOTPSWD = '/forgot-password';
export const PARAMS = '/params';